module.exports = __webpack_public_path__ + "static/img/安全可信.802e4672.png";